module.exports = "<div class=\"footer-wrapper\" [class.show-line]=\"showLine\">\n  <div class=\"footer-dark-logo\" *ngIf=\"showLine\">quibbl</div>\n  <a [routerLink]=\"'/about'\" routerLinkActive=\"active\">About Us</a>\n  <a [routerLink]=\"'/terms'\" routerLinkActive=\"active\">Terms of Service</a>\n  <div class=\"copyright\">&copy; 2017 Quibbl</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/common/footer/footer.component.html
// module id = ../../../../../src/app/common/footer/footer.component.html
// module chunks = main